module.exports = __webpack_public_path__ + "img/china-map.f4991f4e.png";